import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Users, FileSignature, ShieldCheck, Briefcase, GitPullRequest } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  const cards = stats ? [
    { label: "Pending Inquiries", value: stats.pending_inquiries, icon: CalendarClock, to: "/admin/inquiries" },
    { label: "Open Applications", value: stats.open_applications, icon: GitPullRequest, to: "/admin/applications" },
    { label: "Active Candidates", value: stats.active_candidates, icon: Users, to: "/admin/candidates" },
    { label: "Offers Outstanding", value: stats.offers_outstanding, icon: FileSignature, to: "/admin/applications" },
    { label: "Published Jobs", value: stats.published_jobs, icon: Briefcase, to: "/admin/jobs" },
    { label: "Compliance Rate", value: `${stats.compliance_rate}%`, icon: ShieldCheck, to: "/admin/applications" },
  ] : [];

  return (
    <div>
      <p className="eyebrow">Command Center</p>
      <h1 className="mt-3 font-serif text-3xl tracking-tight">Dashboard</h1>
      <p className="mt-2 font-sans text-sm text-[#94A3B8]">Live overview of bookings and recruitment operations.</p>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => (
          <button
            key={c.label}
            onClick={() => navigate(c.to)}
            data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="group rounded-lg border border-white/5 bg-[#121722] p-6 text-left transition-all hover:border-gold/30"
          >
            <div className="flex items-center justify-between">
              <p className="font-mono text-[10px] uppercase tracking-widest text-[#94A3B8]">{c.label}</p>
              <c.icon size={18} className="text-gold" />
            </div>
            <p className="mt-4 font-serif text-4xl text-white">{c.value}</p>
          </button>
        ))}
      </div>

      {!stats && <p className="mt-8 font-sans text-sm text-[#94A3B8]">Loading metrics…</p>}
    </div>
  );
}
